import React from "react";
import Form from "./common/form";
import {
  getSystemIDfromHandle,
  getSystem,
  deleteSystem,
} from "../services/systemService";
import { masterCompany } from "../config.json";
import BackGroundRectangle from "../components/backgroundRect";

class DeleteSystem extends Form {
  state = {
    system: {},
    handleId: "",
    systemId: "",
    systemSN: "",
    streetAddress: "",
    cityAddress: "",
    stateAddress: "",

    errors: {},
  };

  async componentDidMount() {
    const handleId = this.props.match.params.systemHandleID;
    const systemId = (await getSystemIDfromHandle(handleId)).data.data
      .system_id;
    const system = (await getSystem(systemId)).data.data[0];
    console.log("System Info", system);
    const systemSN = system.systemID.SN;
    console.log("Serial Number", systemSN);
    this.setState({ systemSN, systemId, system });
  }

  handleDelete = async (e) => {
    e.preventDefault();
    console.log("System ID", this.state.systemId);
    await deleteSystem(this.state.systemId);
    this.props.history.push(
      `/Companies/systems/${this.props.match.params.companyName}`
    );
  };

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            position: "absolute",
            width: "300px",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: "150px",
            marginBottom: "150px",
            zIndex: 1,
          }}
        >
          <p className="basicParagraph">
            You are about to delete the following system:
          </p>
          <p className="basicParagraph">Please confirm:</p>
          <p className="basicParagraph" style={{ color: "red" }}>
            Caution: This operation could only be performed by an Admin at{" "}
            {masterCompany}
          </p>
          <p className="basicParagraph">
            System Handle ID: {this.props.match.params.systemHandleID}
          </p>
          <p className="basicParagraph">Serial Number: {this.state.systemSN}</p>
          {/*<p className="message text-danger">
          Located at: {this.state.streetAddress} in {this.state.cityAddress},{" "}
          {this.state.stateAddress}
      </p>*/}
          <button
            className="btn btn-danger btn-sm"
            style={{ position: "center" }}
            onClick={this.handleDelete}
          >
            Confirm
          </button>
        </div>
        <BackGroundRectangle />
      </React.Fragment>
    );
  }
}

export default DeleteSystem;
